import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardHeader from "@material-ui/core/CardHeader";
import { Split } from "../../utils/Split";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Bar, Line } from "react-chartjs-2";
import Typography from "@material-ui/core/Typography";
import { styled } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useSelector } from "react-redux";
import PBarItem from "./PBarItem";
import {
  BLUE_PRIMARY,
  COLORS,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
} from "../../utils/const";

const ChartArea = (props) => {
  const typesInfo = useSelector((state) => state.typesInfo);

  const labels = Object.keys(typesInfo);

  const data = {
    labels,
    datasets: [
      {
        label: "فروخته شده",
        data: labels.map((label, index) => typesInfo[label].activation),
        // backgroundColor: "#87CEEB",
        backgroundColor: "#e6005c",
        // borderColor: "#EB1D36",
        fill: false,
        barThickness: "flex",
        maxBarThickness: 48,
        minBarLength: 18,
      },
      {
        label: "آماده فروش",
        data: labels.map((label, index) =>
          typesInfo[label].validation - typesInfo[label].activation > 0
            ? typesInfo[label].validation - typesInfo[label].activation
            : 0
        ),
        // backgroundColor: "#6495ED",
        backgroundColor: "#ff3300",
        borderColor: "#395B64",
        fill: false,
        barThickness: "flex",
        maxBarThickness: 48,
        minBarLength: 18,
      },
      {
        label: "ثبت شده",
        data: labels.map((label, index) => typesInfo[label].all_water_meter),
        // backgroundColor: "#20B2AA",
        backgroundColor: "#339933",
        borderColor: "#395B64",
        fill: false,
        barThickness: "flex",
        maxBarThickness: 48,
        minBarLength: 18,
      },
    ],
  };

  const options = {
    legend: { labels: { fontFamily: "Vazir" }, rtl: false },
    scales: {
      yAxes: [
        {
          ticks: {
            // fontSize: 40
            fontFamily: "Vazir",
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              return Split(convertNumbers(label));
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontFamily: "Vazir",
            userCallback: (label, index, labels) => {
              return convertNumbers(label);
            },
          },
          offset: true,
        },
      ],
    },
    tooltips: {
      bodyFontFamily: "Vazir",
      // mode: 'label',
      callbacks: {
        title: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return convertNumbers(data.labels[indice]);
        },
        label: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return (
            "نوع " +
            labels[indice] +
            " - " +
            "تعداد کنتور" +
            ": " +
            Split(
              convertNumbers(
                data.datasets[tooltipItem.datasetIndex].data[indice]
              )
            ) +
            ""
          );
        },
      },
    },
  };

  return (
    <div style={{ paddingRight: "8px", paddingLeft: "8px" }}>
      <Card
        style={{
          marginTop: "16px",
          backgroundColor: "white",
          paddingBottom: "24px",
          paddingTop: "8px",
          paddingRight: "24px",
          paddingLeft: "24px",
        }}
      >
        <CardHeader
          style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
          title={"تعداد کنتورها بر حسب نوع"}
        />

        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={8}>
            <Bar options={options} data={data} />
          </Grid>
          <Grid
            style={{
              padding: "16px",
              paddingBottom: "16px",
              paddingTop: "24px",
            }}
            item
            xs={12}
            sm={12}
            md={12}
            lg={4}
          >
            <Typography style={{ color: "#73879c", fontSize: "18px" }}>
              میزان کنتورهای فروش رفته
            </Typography>
            <div
              style={{
                paddingBottom: "4px",
                borderBottom: "2px solid #e6e9ed",
              }}
            ></div>
            <div style={{ maxHeight: "320px", overflow: "scroll" }}>
              {labels.map((label, idx) => {
                const selledValue = data.datasets[0].data[idx];
                const registeredValue = data.datasets[2].data[idx];
                const d = {
                  name: label,
                  value:
                    selledValue === 0
                      ? 0
                      : ((selledValue / registeredValue) * 100.0).toFixed(2),
                  selledValue: selledValue,
                  registeredValue: registeredValue,
                };
                return <PBarItem data={d} />;
              })}
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default ChartArea;
